import { TFunction } from 'i18next';
import Phonenumber from 'awesome-phonenumber';

export function validatePhone(t: TFunction, phone: string | null | undefined) {
    const pn = new Phonenumber(phone ?? '');
    if (pn.isValid()) {
        return undefined;
    }
    return t('validation:wrongPhone');
}
export function validateEmail(
    t: TFunction,
    mail: string | undefined
): string | undefined {
    if (mail) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return undefined;
        }
    }
    return t('validation:wrongEmail');
}

export function requiredItem(
    t: TFunction,
    value:
        | string
        | Date
        | number
        | string[]
        | Date[]
        | number[]
        | null
        | undefined,
    fieldName: string
): string | undefined {
    if (value && value !== -1) {
        return undefined;
    }
    return t('validation:isRequired', { fieldName });
    // return `${fieldName} is required`;
}
export function required(
    t: TFunction,
    value:
        | string
        | Date
        | number
        | string[]
        | Date[]
        | number[]
        | null
        | undefined,
    fieldName: string
): string | undefined {
    if (value) {
        return undefined;
    }
    return t('validation:isRequired', { fieldName });
    // return `${fieldName} is required`;
}
export type ValidationFunction = () => string | undefined;
export function combine(validations: ValidationFunction[]): string | undefined {
    if (validations) {
        // eslint-disable-next-line no-restricted-syntax
        for (const validation of validations) {
            const errorMessage = validation();
            if (errorMessage) {
                return errorMessage;
            }
        }
    }
    return undefined;
}
